import React, { useState, useContext } from 'react';
import { Typography, IconButton } from '@one-thd/sui-atomic-components';
import { NavigationDrawer } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { More } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';
export var PageTitle = function (_a) {
    var title = _a.title, shouldShowDrawer = _a.shouldShowDrawer, dataTestId = _a.dataTestId;
    var isConsumerApp = useContext(ExperienceContext).isConsumerApp;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (React.createElement("div", { className: "sui-flex sui-justify-between sui-items-center lg:sui-block" },
        React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true, "data-testid": dataTestId }, title),
        shouldShowDrawer && !isConsumerApp && (React.createElement(ErrorBoundary, { name: "customer-account-navigation-mobile-view" },
            React.createElement("div", { className: "sui-block lg:sui-hidden" },
                React.createElement(IconButton, { icon: More, onClick: function () {
                        setIsOpen(function (prev) {
                            return !prev;
                        });
                    }, "aria-label": "Open Navigation" }),
                React.createElement(NavigationDrawer, { open: isOpen, onClose: function () {
                        setIsOpen(false);
                    } }))))));
};
